<template>
  <div>
    <v-expansion-panels flat accordion v-model="panels" multiple>
      <v-expansion-panel
        class="mt-n4 ml-n6 "
        flat
        v-for="(c, i) in vModel"
        :key="c._id"
        @click.prevent="togglePanel(i)"
      >
        <v-expansion-panel-header>
          <v-toolbar
            :class="$vuetify.breakpoint.mdAndUp ? 'mt-n2' : 'ml-n8'"
            flat
            small
          >
            <v-chip class="pl-4" large label outlined :color="getColor(c)">
              <div
                :class="
                  $vuetify.breakpoint.mdAndUp
                    ? 'pt-4 pr-6 mr-2'
                    : 'mt-n1 ml-n1 mr-1'
                "
                v-if="data_object.calculatedAvatar"
              >
                <v-form-component
                  :data_object="data_object"
                  :model="c"
                  :parentModel="parentModel"
                  :parModel="parModel"
                  :schema="getAvatarSchema()"
                  :parentSchema="parObject || {}"
                  :onValueChange="onValueChange"
                ></v-form-component>
                <!-- <v-icon large>{{ getAvatar(c) }}</v-icon> -->
              </div>
              <h4 class="pointer mr-2" @click="togglePanel(i)">
                {{ header(c) }}
              </h4>
              <v-spacer></v-spacer>
              <v-chip
                class="ml-4"
                v-if="data_object.chipProperty"
                :key="totalKey + c._id"
              >
                {{ getChipSchema(true).title }}:
                {{ c[data_object.chipProperty] }}
              </v-chip>
            </v-chip>

            <v-spacer></v-spacer>
            <v-tooltip v-if="data_object.recordAction" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  @click="data_object.recordAction.fn(c, i)"
                >
                  <v-icon>{{ data_object.recordAction.icon }}</v-icon>
                </v-btn>
              </template>
              {{ data_object.recordAction.caption }}
            </v-tooltip>
            <v-tooltip v-if="data_object.canDelete" bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="red" icon v-on="on" @click="deleteRec(c, i)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              Delete Record
            </v-tooltip>
          </v-toolbar>
          <template v-slot:actions>
            <v-btn icon @click.stop="togglePanel(i)">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form-component
            :data_object="data_object"
            :model="c"
            :parentModel="parentModel"
            :parModel="parModel"
            :schema="schema[k].properties"
            :onValueChange="onValueChange"
            :parentSchema="parObject || {}"
          ></v-form-component>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-label-button
      :schema="schema[k]"
      :model_key="k"
      :data_key="nameKey"
      :v-model="parModel"
      :itemModel="vModel"
      :formModel="formModel"
      :parSchema="schema"
      :addBtnTitle="addBtnTitle"
      :addBtn="true"
      :addRec="addRec"
    />
    <v-alert
      class="ma-4"
      dismissible
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
Vue.use(VueAxios, axios);
export default {
  name: "Collapsible",
  components: {
    VFormComponent: () => import("./FormComponent.vue"),
    VLabelButton: () => import("./LabelButton.vue"),
    // VDeleteButton: () => import("./DeleteButton.vue"),
  },
  props: {
    vModel: [Array, Object],
    data_object: Object,
    parModel: [Object, Array, String],
    parentModel: [Object, Array, String],
    formModel: [Object, Array, String],
    parObject: Object,
    parentObject: Object,
    label: String,
    schema: Object,
    k: String,
    additionalModel: Object,
    addBtnTitle: String,
    expandedPanels: Array,
    onValueChange: Function,
  },
  data() {
    return {
      // panel: [0],
      panels: [0],
      color: "",
      totalKey: 0,
      errorMessage: "",
      nameKey: "",
    };
  },
  mounted() {
    if (this.expandedPanels) {
      this.panels = this.expandedPanels;
    }
    console.log(this.vModel);
  },
  beforeDestroy() {},
  watch: {},
  methods: {
    getAvatarSchema() {
      var schema = fun.clone(this.schema[this.k].properties);
      var avatar = this.data_object.calculatedAvatar;
      Object.keys(schema).forEach(function(k) {
        if (k != avatar) {
          delete schema[k];
        }
      });
      schema[avatar].hidden = false;
      return schema;
    },
    togglePanel(i) {
      if (!this.panels) {
        this.panels = [];
      }
      if (!this.panels.includes(i)) {
        this.panels.push(i);
      } else {
        this.panels.splice(this.panels.indexOf(i), 1);
      }
    },
    deleteRec(r, i) {
      console.log(r);
      this.$root.$confirm
        .open(
          "Delete",
          "Confirm deleting " +
            fun.capitalize(r[this.data_object.name_key]) +
            "?",
          {
            color: "red",
          }
        )
        .then((confirm) => {
          if (confirm) {
            this.vModel.splice(i, 1);
          }
        });

      // this.vModel.splice()
      // var that = this;
      // var data = {};
      // axios
      //   .post(this.serverURL + "/delete_records", data, {
      //     withCredentials: true,
      //   })
      //   .then((response) => {
      //     that.successMessage = response.data;

      //   });
    },
    getAvatar(r) {
      return eval(this.data_object.calculatedAvatar);
    },
    capitalize(h) {
      return fun.capitalize(h);
    },
    header(r) {
      var h = "";
      if (this.data_object.calculatedTitle) {
        h = eval(this.data_object.calculatedTitle);
      }
      // if (this.getColor(r)) {
      //   h = "<span style='color:white' >" + h + "</span>";
      // }
      return h;
    },

    getChipSchema(p) {
      var s = {};
      var prop = this.schema[this.k].properties[this.data_object.chipProperty];
      // prop["v-bind"].readonly = true;
      // prop.cssstyle = "margin-top:-32px";
      s[this.data_object.chipProperty] = prop;

      if (p) {
        return prop;
      } else {
        return s;
      }
    },
    getColor(r) {
      var color = "";
      if (this.data_object.calculatedHeaderColor) {
        try {
          color = eval(this.data_object.calculatedHeaderColor);
        } catch (error) {
          console.log(error);
        }
      }

      return color.toString();
    },

    addRec(r) {
      var newRec = {};
      var props = this.schema[this.k].properties;
      var collectionTypes = ["d-table", "d-iterator", "d-list"];
      Object.keys(props).forEach((p) => {
        if (props[p]["object_type"]) {
          newRec[p] = {};
        }
        if (collectionTypes.includes(props[p]["x-display"])) {
          newRec[p] = [];
        }
      });
      var nameKey = this.nameKey;
      if (!nameKey) {
        nameKey = this.schema[this.k].name_key;
      }

      newRec[nameKey] = r;
      if (this.data_object.calculatedDefault) {
        eval(this.data_object.calculatedDefault);
        // this.defStops(newRec, r);
      }
      newRec._id = fun.guid();

      this.vModel.push(newRec);
      this.panels.push(this.vModel.length - 1);
      // var key = {
      //   id: newRec._id,
      //   key: this.vModel.length - 1,
      // };
      // this.allKeys.push(key);
      // this.itemsKey = !this.itemsKey;
    },
  },
  // computed: {
  //   // nameKey() {
  //   //   var s = this.getSchema();
  //   //   return s[this.k]["name_key"];
  //   // },
  // addBtnTitle() {
  //   var s = this.data_object;
  //   return  s["add_btn_title"];
  // },
  // },
};
</script>

<style>
.short {
  width: 20px !important;
}
/* .short span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
